export const getRecentlyUsedPropertiesSuperStoreKey = objectTypeId => `${objectTypeId}:recently-used-properties`;